export const LOCKOUT_REASON = {
  TRIAL_EXPIRED: 'TRIAL_EXPIRED',
  TRIAL_NOT_STARTED: 'TRIAL_NOT_STARTED',
  TRIAL_PENDING: 'TRIAL_PENDING',
  TRIAL_REJECTED: 'TRIAL_REJECTED',
  SUBSCRIPTION_INACTIVE: 'SUBSCRIPTION_INACTIVE',
  LOCKED: 'LOCKED',
} as const;
